import axios from "axios";
import Config from "../../../../../config";

const v2_actionGerarExcelRelatorioNegocios = (querys, body) => {
    const url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/dashboard/relatorios/excel/analitico-leads-funil${querys}`;

    if (body) {
        return axios({
            method: "post",
            url,
            data: body,
            responseType: 'blob'
        });
    }

    return axios({
        method: "get",
        url,
        responseType: 'blob'
    });
};

export default v2_actionGerarExcelRelatorioNegocios;
